<template>
  <div class="gyzhmain">
    <!-- 大图 -->
    <div class="bigbgi">
      <div class="midbgi">
      </div>
    </div>
    <div class="gyzgcont">

      <el-row>
        <el-col :span="5">
          <div class="cdtitle">VISIT</div>
          <el-menu @select="handleSelect" :default-active="pageNum" class="gyzhcd  el-menu-vertical-demo" text-color="#000" active-text-color="#1D50A2">
            <el-menu-item index="1">CIEPEC2026 information</el-menu-item>
            <el-menu-item index="2" @click="cgdj">Registration</el-menu-item>

          </el-menu>

          <!-- 展出时间 -->
          <div class="zcsj">
            Exhibit Hours
          </div>
          <div>
            <div class="rqys">
              <div class="greendian"></div>
              <div class="rcsj">
                June 2, 2026, 9:00am-5:00pm
              </div>
            </div>
            <div class="rqys">
              <div class="greendian"></div>
              <div class="rcsj">
                June 3, 2026, 9:00am-5:00pm
              </div>
            </div>
            <div class="rqys">
              <div class="greendian"></div>
              <div class="rcsj">
                June 4, 2026, 9:00am-4:00pm
              </div>
            </div>
            <div style="margin-bottom:30px" class="rcsj">
              (Last admission 1 hour before closing)
            </div>
          </div>
        </el-col>
        <el-col :span="18">
          <div style="margin-left:40px;margin-top:20px;margin-right:40px;padding:20px;background-color:#f9f9f9;border-radius:8px">
            <table style="width:100%;border-collapse:collapse;border:1px solid #ddd">
              <tr>
                <td style="border:1px solid #ddd;padding:15px;font-weight:bold;width:50%;background-color:#e6f2ff;font-size:18px">Date:</td>
                <td style="border:1px solid #ddd;padding:15px;font-size:18px">CIEPEC2026</td>
                <td style="border:1px solid #ddd;padding:15px;font-size:18px">2 - 4 June 2026</td>
              </tr>
              <tr>
                <td style="border:1px solid #ddd;padding:15px;font-weight:bold;vertical-align:top;background-color:#e6f2ff;font-size:18px">Opening Hours</td>
                <td style="border:1px solid #ddd;padding:15px;font-size:18px">2 June 2026</td>
                <td style="border:1px solid #ddd;padding:15px;font-size:18px">9:00am – 5:00pm</td>
              </tr>
              <tr>
                <td style="border:1px solid #ddd;padding:15px;font-weight:bold;vertical-align:top;background-color:#e6f2ff;font-size:18px"></td>
                <td style="border:1px solid #ddd;padding:15px;font-size:18px">3 June 2026</td>
                <td style="border:1px solid #ddd;padding:15px;font-size:18px">9:00am – 5:00pm</td>
              </tr>
              <tr>
                <td style="border:1px solid #ddd;padding:15px;font-weight:bold;vertical-align:top;background-color:#e6f2ff;font-size:18px"></td>
                <td style="border:1px solid #ddd;padding:15px;font-size:18px">4 June 2026</td>
                <td style="border:1px solid #ddd;padding:15px;font-size:18px">9:00am – 4:00pm</td>
              </tr>
            </table>
          </div>
        </el-col>
      </el-row>

    </div>
  </div>
</template>

<script>
export default {
  name: 'Gyzh',
  data () {
    return {
      menuName: '目标观众',
      pageNum: '1',
      activeNames: []
    }
  },
  methods: {
    handleSelect (key) {
      this.menuName = event.target.innerText.trim()
      this.pageNum = key
      // if (this.pageNum == 6) {
      //   window.location.href = 'https://www.ciepec-online.com/'
      // }
    },

    cgdj () {
      window.location.href = 'https://data.ciec.com.cn/c2l0ZTo1OTI5Mzk/p/v/register'
    }
  }
}
</script>

<style scoped>
.gyzhmain {
  width: 100%;
}
.bigbgi {
  background-image: url('../../assets/home/Header1.png'); /* 设置图片路径 */
  background-repeat: no-repeat; /* 背景图片不重复 */
  background-position: center; /* 背景图片居中 */
  background-size: cover;
  height: 450px; /* 元素高度 */
  width: 100%;
}
.midbgi {
  background-image: url('../../assets/home/renwu.png'); /* 设置图片路径 */
  background-repeat: no-repeat; /* 背景图片不重复 */
  background-position: center; /* 背景图片居中 */
  background-size: 40% 100%;
  height: 450px; /* 元素高度 */
  width: 100%;
}
.gyzgcont {
  width: 80%;
  margin: 0 auto;
}

.gyzhcd {
  background: url('../../assets/index/cebian2.png') no-repeat,
    linear-gradient(180deg, #ffffff 0%, #e4efff 100%);
  background-repeat: no-repeat;
  background-position: center bottom;
  background-size: 100%;

  width: 100%;
}
.el-menu-item {
  text-align: center;
  font-size: 18px;
  color: #16181a;
  letter-spacing: -0px;
  text-align: center;
  font-weight: 400;
}
.el-menu-item.is-active {
  font-weight: bold;
  color: #1d50a2;
}
.cdtitle {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -80px;
  height: 86px;
  color: #fff;
  font-size: 24px;
  color: #ffffff;
  letter-spacing: 0;
  text-align: center;
  font-weight: 700;
  background-image: url('../../assets/index/cebian1.png'); /* 设置图片路径 */
  background-repeat: no-repeat; /* 背景图片不重复 */
  background-position: center; /* 背景图片居中 */
  background-size: cover;
  height: 80px; /* 元素高度 */
  /* width: 100%; */
}
.bread {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: -60px;
  opacity: 0.94;
  background-image: linear-gradient(
    90deg,
    rgba(14, 152, 121, 0) 0%,
    #0e9577 50%
  );
  height: 60px;
  width: 470px;
  float: right;
  font-size: 16px;
  color: #ffffff;
  letter-spacing: 0;
  font-weight: 500;
}
a {
  text-decoration: none;
  font-size: 16px;
  color: #fff;
}
.address {
  opacity: 0.9;
  background: #eff5ff;
  font-size: 18px;
  color: #333333;
  line-height: 34px;
  font-weight: 400;
  padding: 10px;
}
.zcsj {
  margin: 20px 0;
  padding: 10px 0;
  background: #159a7e;
  font-size: 24px;
  color: #ffffff;
  letter-spacing: 0;
  line-height: 24px;
  text-align: center;
  font-weight: 600;
}
.rqys {
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
  height: 40px;
}
.greendian {
  width: 10px;
  height: 10px;
  border-radius: 10px;
  background: #159a7e;
}
.rcsj {
  flex: 1;
  font-size: 18px;
  color: #333333;
  text-align: center;
  line-height: 18px;
  font-weight: 400;
}
.xgtitle {
  width: 280px;
  margin-bottom: 10px;
  margin-top: 5px;
  overflow: hidden; /* 确保超出的内容会被裁剪 */
  white-space: nowrap; /* 确保文本在一行内显示 */
  text-overflow: ellipsis; /* 超出的文本部分显示为省略号 */
  font-size: 18px;
  color: #333333;
  line-height: 32px;
  font-weight: 400;
}
.zhzl {
  font-size: 18px;
  font-weight: normal;
  margin: 0 30px;
  line-height: 45px;
}
h2 {
  text-align: center;
}

.dwname {
  font-size: 18px;
  font-weight: normal;
  margin: 0 30px;
  line-height: 25px;
}

/deep/ .el-collapse-item__header {
  font-size: 18px !important;
  border: none;
  background-color: #f6f4f4f3 !important;
  border-radius: 5px;
  padding: 0 10px;
  height: 50px;
}
/deep/ .el-collapse-item {
  margin-bottom: 20px;
}
/deep/ .el-collapse-item__content {
  font-size: 16px;
  padding: 15px 10px 10px 10px;
  line-height: 32px;
  color: grey !important;
}
/deep/ .el-collapse-item__wrap {
  border: none;
}
.el-collapse {
  border: none;
}
.xz {
  text-decoration: none;
  color: #444;
}
.xz:hover {
  color: #55aa5c;
}
.xztit {
  font-size: 18px;
  line-height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/caidaneng/gzzx.vue